import React from 'react';

export const Message = (props)=>{
	return null;
}

export const ContractCreate = (props)=>{
	return (
		<div className="message">
			<div className="contract-message">
				<p className="d-none">
					Our documents are created and reviewed by lawyers and legal professionals. All you need to do is answer a few questions and your customized document is ready to sign, share, or print in minutes.
				</p>
			</div>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/view/Messages.js